import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import './ModalHelper.scss'
import { FaCrown, FaUser } from 'react-icons/fa';
import { X } from 'react-bootstrap-icons';

// Asegúrate de tener instalado react-bootstrap y bootstrap
// npm install react-bootstrap bootstrap

// Recuerda importar los estilos de bootstrap en tu proyecto (por ejemplo, en index.js o App.js):
// import 'bootstrap/dist/css/bootstrap.min.css';

type Props = {
    show: boolean
    onClose: () => void
}

const ModalHelper = ({ show, onClose }: Props) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header>
                <div className='form-modal-title-container'>
                    <Modal.Title className='form-modal-title'>Íconos y descripciones</Modal.Title>
                </div>
                <Button variant="none" onClick={onClose}>
                    <X size={24} />
                </Button>
            </Modal.Header>
                <Modal.Body>            
            <div className='contenedor-icono-descripcion'>
                <div className='icono-descripcion'>
                    <div className='icono-usuario icon'>
                            H
                    </div>
                    <div className='descripcion-icono'>Inicial del garzón que está atendiendo una mesa. </div> 
                    
                </div>
                
                                {/* Leyendas por colores de borde (sin íconos) */}
                                <div className='icono-descripcion'>
                                    <div className='legend-box border-grey' />
                                    <div className='descripcion-icono'>Borde gris tenue: sugerencia para ofrecer algo más (inactividad desde el último pedido).</div>
                                </div>
                                <div className='icono-descripcion'>
                                    <div className='legend-box border-red' />
                                    <div className='descripcion-icono'>Borde rojo intermitente: mucho tiempo en la mesa (p. ej., más de 2 horas).</div>
                                </div>
                                <div className='icono-descripcion'>
                                    <div className='legend-box border-yellow' />
                                    <div className='descripcion-icono'>Borde amarillo intermitente: cobro pendiente (pasó tiempo desde marcar “cobrado”).</div>
                                </div>
                 
                
                <div className='icono-descripcion'>
                    <div className='mesa-madre'>
                        <FaCrown className='corona-mesa-madre' />
                        <div className='mesa-parte-del-grupo'></div>
                    </div>
                    <div className='descripcion-icono'>
                        Funcionalidad para juntar mesas. Esta es la mesa madre del grupo. Al hacer clic en este ícono se habilitará la opción de separar las mesas.
                    </div>
                </div>

                <div className='icono-descripcion'>
                    <div className='mesa-parte-del-grupo'></div>
                    <div className='descripcion-icono'>
                        Funcionalidad para juntar mesas. Mesa que es parte del grupo. Al hacer clic en este ícono se habilitará la opción de separar las mesas.
                    </div>
                </div>
                                {/* Total cobrado (píldora) */}
                                <div className='icono-descripcion'>
                                    <div className='charges-pill-example'>$25.000</div>
                                    <div className='descripcion-icono'>Píldora con el total cobrado en la mesa. Se actualiza en tiempo real.</div>
                                </div>
                
                
                        
                <div className='icono-descripcion'>
                    <div className='n-mesa'>
                            <p>N° +</p> <FaUser className="icono-capacidad-mesas" title="Capacidad de la mesa" />
                            
                    </div>
                    <div className='descripcion-icono'>El N° grande indica el N° de mesa.</div>
                
                </div>
                
                
                        
                <div className='icono-descripcion'>
                    <div className='capacidad-mesa'>
                            <FaUser className="icono-capacidad-mesas" title="Capacidad de la mesa" /> <p>+ N°</p>
                            
                    </div>
                    <div className='descripcion-icono'>Capacidad de personas de la mesa. </div>
                
                </div>
                
            </div>
            
            
        </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalHelper
